<cm-status-indicator-step class="status-indicator" [status]="colorStatusId" [tooltip]="tooltip">
</cm-status-indicator-step>
<img class="icon-img certificate-icon" *ngIf="logo" [src]="logo" />
<cm-icon *ngIf="!logo" class="placeholder" name="company-logo-placeholder"></cm-icon>
